import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface IHomehealthStateSlice {
  error: unknown;
  homehealthState: IReduxLoadingState;
  patients: IHHPatientsList;
  loading: boolean;
  c100DeviceIdDictionary: Dictionary<IHHPatient>;
}

const name = "homehealth";

export const initialState: IHomehealthStateSlice = {
  homehealthState: "pending",
  error: "",
  patients: [],
  c100DeviceIdDictionary: {},
  loading: false,
};

export const homehealthSlice = createSlice({
  name,
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setHomehealthState: (
      state,
      action: PayloadAction<Partial<IHomehealthStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    setHomehealthSliceReset() {
      return initialState;
    },
  },
  extraReducers() {},
});

export const { setLoading, setHomehealthState, setHomehealthSliceReset } =
  homehealthSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["patients"],
  },
  homehealthSlice.reducer
);

export default persistedReducer;
